var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { EStaticFilterOperator, } from "@domains/features/Markets/MutualFunds/dto/MutualFundsSchemesDTO";
import GenericSelect from "@frameworks/shared-library/components/GenericSelect/GenericSelect";
import React from "react";
import InputField from "@frameworks/web/components/generic/inputField";
import { floatNumWithNegativesExp } from "@frameworks/web/utils/regex";
import "@frameworks/shared-library/stylesheets/components/Offerings/Generic/GenericFilterSort/OfferingsRangeFilters/OfferingsRangeFilters.scss";
var labelMap = {
    ">": {
        label: "Above",
        value: EStaticFilterOperator.GREATER_THAN,
    },
    "<": {
        label: "Below",
        value: EStaticFilterOperator.SMALLER_THAN,
    },
    "=": {
        label: "Below",
        value: EStaticFilterOperator.SMALLER_THAN,
    },
};
var OfferingsRangeFilters = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var _g = props.showInputSuffix, showInputSuffix = _g === void 0 ? true : _g;
    var generateValueFieldForSelect = function () {
        var _a, _b, _c;
        var label = "";
        var value = undefined;
        value = props === null || props === void 0 ? void 0 : props.mutualFundFilterSortValues[props.typeOfFilter];
        label = ((_a = props === null || props === void 0 ? void 0 : props.mutualFundFilterSortValues[props.typeOfFilter]) === null || _a === void 0 ? void 0 : _a.operator)
            ? (_c = labelMap[(_b = props === null || props === void 0 ? void 0 : props.mutualFundFilterSortValues[props.typeOfFilter]) === null || _b === void 0 ? void 0 : _b.operator]) === null || _c === void 0 ? void 0 : _c.label
            : "";
        if (value && !!label) {
            return { label: label, value: value };
        }
        else {
            return null;
        }
    };
    return (React.createElement("div", { className: "d-flex flex-column gap-3 p-3 bg-ghost-white3 h-100 primary-offerings-range-filters" },
        React.createElement(GenericSelect, { options: [
                {
                    label: "Above",
                    value: {
                        operator: EStaticFilterOperator.GREATER_THAN,
                    },
                },
                {
                    label: "Below",
                    value: {
                        operator: EStaticFilterOperator.SMALLER_THAN,
                    },
                },
            ], value: generateValueFieldForSelect(), onChange: function (data) {
                props.onDropDownChange(data, props.typeOfFilter);
            }, showSelectOptionByDefault: false, errorText: ((_a = props === null || props === void 0 ? void 0 : props.errorData) === null || _a === void 0 ? void 0 : _a.hasOwnProperty(props === null || props === void 0 ? void 0 : props.typeOfFilter))
                ? props.errorData[props === null || props === void 0 ? void 0 : props.typeOfFilter].selectError
                : "", classNamePrefix: "range-filters-select", className: "primary-range-filters-select" }),
        React.createElement(InputField, __assign({ className: "range-filters-input input-placeholder-dull-gray d-flex align-items-center", placeholderClassName: "d-none", placeholder: (props === null || props === void 0 ? void 0 : props.inputPlaceholder) ? props === null || props === void 0 ? void 0 : props.inputPlaceholder : "Enter percentage", inputMode: "numeric", type: "number", maxLength: props === null || props === void 0 ? void 0 : props.inputLimit, float: floatNumWithNegativesExp(3) }, (showInputSuffix && {
            suffix: "%",
        }), { defaultValue: (_c = (_b = props.mutualFundFilterSortValues[props.typeOfFilter]) === null || _b === void 0 ? void 0 : _b.value) !== null && _c !== void 0 ? _c : "", value: (_e = (_d = props.mutualFundFilterSortValues[props.typeOfFilter]) === null || _d === void 0 ? void 0 : _d.value) !== null && _e !== void 0 ? _e : "", onChangeEvent: function (e) {
                props.onInputFormChange(e.target.name, e.target.value, props.typeOfFilter);
            }, errorText: ((_f = props === null || props === void 0 ? void 0 : props.errorData) === null || _f === void 0 ? void 0 : _f.hasOwnProperty(props === null || props === void 0 ? void 0 : props.typeOfFilter))
                ? props.errorData[props === null || props === void 0 ? void 0 : props.typeOfFilter].inputError
                : "", onKeyDown: function (e) {
                if (e.key === "e" || e.key === "E") {
                    e.preventDefault(); // Prevent 'e' from being typed as type = "number" takes "e" as a valid value
                }
            } }))));
};
export default OfferingsRangeFilters;
